export default {
  typography: {
    htmlFontSize: 11,
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {
    primary: {
      light: '#4791db',
      main: '#3f51b5',
      dark: '#115293',
    },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': ['Poppins'],
      },
    },
    MuiButton: {
      text: {
        color: 'white',
      },
    },
  },
};
